import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { HomeComponent } from './modules/admin/home/home.component';
import { InspectorComponent } from './modules/admin/inspector/inspector.component';
import { RightsResolver } from './core/resolver/rights-resolver';

export const appRoutes: Route[] = [
    { path: '', pathMatch: 'full', redirectTo: 'home' },
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.routes'),
            },
        ],
    },

    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'password-reset',
                canActivate: [AuthGuard],
                loadChildren: () =>
                    import(
                        'app/modules/auth/reset-password/reset-password.routes'
                    ),
            },
        ],
    },

    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'home',
                component: HomeComponent,
                resolve: {
                    init: RightsResolver,
                },
            },
            {
                path: 'inspector',
                component: InspectorComponent,
                resolve: {
                    init: RightsResolver,
                },
            },
            {
                path: 'newsfeed',
                loadChildren: () =>
                    import('app/modules/admin/newsfeed/newsfeed.routes'),
            },
            {
                path: 'events',
                loadChildren: () =>
                    import('app/modules/admin/events/events.routes'),
            },
            {
                path: 'event-data',
                loadChildren: () =>
                    import('app/modules/admin/event-data/event-data.routes'),
            },
            {
                path: 'statistics',
                loadChildren: () =>
                    import('app/modules/admin/statistics/statistics.routes'),
            },
            {
                path: 'performance',
                loadChildren: () =>
                    import('app/modules/admin/performance/performance.routes'),
            },
            {
                path: 'material-management',
                loadChildren: () =>
                    import(
                        'app/modules/admin/material-management/material-management.routes'
                    ),
            },
            {
                path: 'fleet',
                loadChildren: () =>
                    import('app/modules/admin/fleet/fleet.routes'),
            },
            {
                path: 'software',
                loadChildren: () =>
                    import('app/modules/admin/software/software.routes'),
            },
            {
                path: 'time-tracking',
                loadChildren: () =>
                    import(
                        'app/modules/admin/time-tracking/time-tracking.routes'
                    ),
            },
            {
                path: 'export',
                loadChildren: () =>
                    import('app/modules/admin/export/export.routes'),
            },
            {
                path: 'team',
                loadChildren: () =>
                    import('app/modules/admin/team/team.routes'),
            },
            {
                path: 'system',
                loadChildren: () =>
                    import('app/modules/admin/system/system.routes'),
            },
        ],
    },
];
